export default __webpack_public_path__ + "static/media/team1.26307a2c.png";